import { render } from "./ServiceFee.vue?vue&type=template&id=1d10f406"
import script from "./ServiceFee.vue?vue&type=script&lang=js"
export * from "./ServiceFee.vue?vue&type=script&lang=js"

import "./ServiceFee.vue?vue&type=style&index=0&id=1d10f406&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__